export default "__VITE_ASSET__DScHlxg3__"